import { Component, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from "@angular/router"
import { AuthService } from '../../shared/auth.service'
import { AjaxService } from 'src/app/shared/ajax.service'
import { GlobService } from 'src/app/shared/glob.service'
import { AlerterService } from 'src/app/shared/alerter.service'
import { UtilService } from 'src/app/shared/util.service'

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {
  constructor(private util: UtilService, public glob: GlobService, private authService: AuthService, private router: Router, private arout: ActivatedRoute, private alerter: AlerterService, private ajax: AjaxService) { }
  // glob: any = glob
  email: string
  password: string
  plan: any
  cplan_id: number = null
  cplan: any
  count: number
  cost: string

  ngOnInit() {
    this.ajax.execute({
      url: 'plan/get_actives',
      success: (post: any) => {
        this.plan = post.result
      }
    })

    if (this.arout.snapshot.queryParams["active"]) {
      let id = this.arout.snapshot.queryParams["active"]
      if (id && id.length == 18) {
        this.ajax.execute({
          url: 'session/active',
          data: { id }
        })
        setTimeout(() => {
          this.router.navigate(['/account/login'])
        }, 2000);
      }
    }

    let authority = this.arout.snapshot.queryParams["Authority"]
    let status = this.arout.snapshot.queryParams["Status"]
    //http://localhost:4200/payment/payback?Authority=000000000000000000000000000122378864&Status=OK
    if (authority)
      if (status === 'OK') {
        this.ajax.execute({
          url: 'payment/payback',
          data: { authority: authority },
          success: (post) => {
            // this.alerter.success('پرداخت با موفقیت انجام شد')
            this.router.navigate(['/account/login'])
          }
        })
      }
      else {
        this.alerter.warning('پرداخت انجام نشد')
      }
  }

  ngAfterViewInit() {
    let t :any  = $('.account input[data-toggle="tooltip"]')
    t.tooltip()
  }

  register() {
    if (!this.validate()) return

    var data = {
      email: this.email.toLowerCase(),
      password: this.password,
      plan_id: this.cplan.id,
      count: this.count,
      domain: this.glob.domain
    }

    this.authService.register(data, () => {
      this.router.navigate(['/account/login'])
    })
  }

  payment() {
    this.ajax.execute({
      url: 'payment/payfront',
      data: { email: this.email, password: this.password, count: this.count, plan_id: this.cplan_id },
      success: (post) => {
        window.location.href = post.result.url
      }
    })
  }

  plan_change(event) {
    let option = $(event.target).find('option:eq(0)')
    if (option.val() == 'null') option.remove()
    this.cplan = this.plan.find(x => x.id == this.cplan_id)
    if (this.cplan.no == 0) this.count = 1
    this.cost = this.count ? this.util.separate((this.count * parseInt(this.cplan.dev_monthly_cost)).toString(), ',', 3) + ' تومان' : ''
  }

  validate() {
    let m = ''
    if (!this.email) m = 'فیلد "ایمیل" الزامی است'
    else if (!new RegExp('[a-z0-9._%+-]{2,}@[a-z0-9.-]{3,}\.[a-z]{2,}').test(this.email)) m = 'مقدار فیلد "ایمیل" معتبر نیست'
    else if (!this.password) m = 'فیلد "رمز عبور" الزامی است'
    else if (!new RegExp('(?=.*[1-9])(?=.*[a-zA-Z]).{6,}').test(this.password)) m = 'برای فیلد "رمز عبور" مقدار 6 کاراکتری یا بیشتر انتخاب کنید و در آن از عدد و حروف انگلیسی استفاده کنید'
    else if (!this.cplan) m = 'فیلد "طرح" الزامی است'
    else if (this.cplan.no != 0 && !this.count) m = 'فیلد "تعداد" الزامی است'

    if (m != '') { this.alerter.warning(m); return false }
    else return true
  }
}